module.exports = __webpack_public_path__ + "images/icon/checkbox_minus_disable-8e0bb185.svg";